<h1 mat-dialog-title >Edite el Proveedor</h1>
<div class="container">
  <mat-card-content style="width: 100%">

    <!--    servicios-->
    <div style="display: flex;flex-wrap: wrap; justify-content: center;">
      <form >
        <mat-form-field appearance="outline" style="margin-right: 20px">
          <mat-label>Servicio</mat-label>
          <input type="text"
                 placeholder="Elige un servicio"
                 matInput
                 [formControl]="myControl"
                 [matAutocomplete]="auto"
          >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)='getProvidersByService($event.option.value)' [displayWith]="getOptionTextService">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option.nombreServicio}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>


      <form  >
        <mat-form-field appearance="outline" style="margin-right: 20px">
          <mat-label>Proveedor</mat-label>
          <input type="text"
                 placeholder="Elige un proveedor"
                 matInput
                 [formControl]="proveedorForm"
                 [matAutocomplete]="auto2"
          >
          <mat-autocomplete #auto2="matAutocomplete" [displayWith]="getOptionText">
            <mat-option *ngFor="let option of filteredProveedores | async" [value]="option">
              {{option.nombre}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>

<!--      <form  >-->
<!--        <mat-form-field appearance="outline" style="margin-right: 20px">-->
<!--          <mat-label>Tarifa</mat-label>-->
<!--          <input type="text"-->
<!--                 placeholder="Elige una tarifa"-->
<!--                 matInput-->
<!--                 [formControl]="tarifaForm"-->
<!--                 [matAutocomplete]="auto3"-->
<!--          >-->
<!--          <mat-autocomplete #auto3="matAutocomplete" [displayWith]="getOptionTextTarifa">-->
<!--            <mat-option *ngFor="let option of filteredTarifas | async" [value]="option">-->
<!--              {{option.nombre}}-->
<!--            </mat-option>-->
<!--          </mat-autocomplete>-->
<!--        </mat-form-field>-->
<!--      </form>-->

      <button mat-mini-fab class="buttonPrimary"  (click)="modifyElement2()" >
        <mat-icon >add</mat-icon>
      </button>


      

    </div>

    <div style="display: flex; justify-content: end; margin: 1rem;;">
      <button mat-raised-button  style=" color: white; background-color: coral"  (click)="servicesByCantPersonalFx()">Replicar Servicios</button>

    </div>


<!--    <div style="margin-bottom: 30px" class="example-container mat-elevation-z8">-->

<!--      <table mat-table class="mat-elevation-z8" [dataSource]="dataSourceDialog" style="width: 100%">-->

<!--        &lt;!&ndash; Name Column &ndash;&gt;-->

<!--        <ng-container matColumnDef="id">-->
<!--          <th mat-header-cell *matHeaderCellDef> Categoría Servicio </th>-->
<!--          <td mat-cell *matCellDef="let element"> {{element.categoriaServicio}} </td>-->
<!--        </ng-container>-->

<!--        <ng-container matColumnDef="nombreServicio">-->
<!--          <th mat-header-cell *matHeaderCellDef> Nombre Servicio </th>-->
<!--          <td mat-cell *matCellDef="let element"> {{element.nombreServicio}} </td>-->
<!--        </ng-container>-->


<!--        <ng-container matColumnDef="nombreProveedor">-->
<!--          <th mat-header-cell *matHeaderCellDef> Nombre Proveedor </th>-->
<!--          <td mat-cell *matCellDef="let element"> {{element.nombreProveedor}} </td>-->
<!--        </ng-container>-->

<!--&lt;!&ndash;        <ng-container matColumnDef="eliminar">&ndash;&gt;-->
<!--&lt;!&ndash;          <mat-header-cell *matHeaderCellDef> </mat-header-cell>&ndash;&gt;-->
<!--&lt;!&ndash;          <td mat-cell *matCellDef="let element;let i=index">&ndash;&gt;-->
<!--&lt;!&ndash;            <button mat-icon-button color="primary" (click)="deleteRow(i)">&ndash;&gt;-->
<!--&lt;!&ndash;              <mat-icon>delete</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;            </button>&ndash;&gt;-->
<!--&lt;!&ndash;          </td>&ndash;&gt;-->
<!--&lt;!&ndash;        </ng-container>&ndash;&gt;-->

<!--        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>-->
<!--        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
<!--      </table>-->
<!--    -->
<!--    </div>-->


    <table mat-table style="width: 100%;table-layout: fixed" [dataSource]="dataSourceDialog"  multiTemplateDataRows  class="mat-elevation-z8">


      <ng-container  matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
        <th mat-header-cell *matHeaderCellDef> {{column.toUpperCase()}} </th>
        <td mat-cell *matCellDef="let element"> {{element[0][column]}} </td>
      </ng-container>



<!--      <ng-container matColumnDef="edit">-->
<!--        <th mat-header-cell *matHeaderCellDef >-</th>-->
<!--        <td mat-cell *matCellDef="let element; let i =dataIndex" (click)="$event.stopPropagation()" >-->
<!--          <button (click)="openDialogEdit(element.fileId)" mat-icon-button color="primary">-->
<!--            <mat-icon>edit</mat-icon>-->
<!--          </button>-->
<!--        </td>-->
<!--      </ng-container>-->

      <!-- <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button aria-label="expand row" (click)="(modelExpand = modelExpand === element ? null : element); $event.stopPropagation()">
            <mat-icon class="icon-color" *ngIf="modelExpand !== element">keyboard_arrow_down</mat-icon>
            <mat-icon class="icon-color" *ngIf="modelExpand === element">keyboard_arrow_up</mat-icon>
          </button>
        </td>
      </ng-container> -->


      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
          <div class="example-element-detail"
               [@detailExpand]="element == modelExpand ? 'expanded' : 'collapsed'" >


            <div class="example-element-description" >
              <div>
                <div class="example-element-description-attribution" > Proveedores: </div>
                <br>
                <div *ngFor="let row of element;let in=index">
              
                    <div *ngIf="row.isDeleted!=true"  >
                    <div class="example-element-description-attribution" >
                      {{row.nombreProveedor}}
                    </div>
                    <div class="example-element-description-attribution">
                      <button mat-icon-button color="primary" (click)="deleteRow(element,in)">
                        <mat-icon class="icon-color">delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <br>
              </div>
            </div>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
          class="example-element-row"
          [class.example-expanded-row]="modelExpand === element"
          (click)="modelExpand = modelExpand === element ? null : element">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

    </table>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>



    <mat-dialog-actions align="center">
      <button mat-raised-button mat-dialog-close>Cancelar</button>
      <button (click)="updatePersonalCampo()" mat-raised-button class="buttonPrimary" >Editar Datos</button>
    </mat-dialog-actions>

  </mat-card-content>
</div>
